import React from 'react';
import { Navigate } from 'react-router-dom';

import BlankMain from './BlankMain';

const Blank = ({ tenantId }) => {
  return tenantId ? <Navigate to={{ pathname: `/${tenantId}` }} replace /> : <BlankMain />;
};

export default Blank;
